import React from "react"
import { injectIntl } from "react-intl"
import { PricingTableItemWrapperProps } from "../common/types"
import PricingTableBundle from "./PricingTableBundle"
import PricingTableItemComponent from "./PricingTableItemComponent"

const PricingTableItemWrapper = (props: PricingTableItemWrapperProps) => {
    if (props.isBundle) {
        return <>
            <PricingTableBundle
                {...props}
            />
        </>
    }
    return (
        <>
            <PricingTableItemComponent
                {...props}
            />
        </>
    )
}


export default injectIntl(PricingTableItemWrapper)


// WEBPACK FOOTER //
// ./src/pricing/PricingTableItemWrapper.tsx